import { useHistory, useParams } from "react-router-dom";
import { api } from "../../services/api";

type ParamsProps = {
  id: string;
  data: string;
};

function ValidateTerms() {
  const history = useHistory();
  const { id } = useParams<ParamsProps>();

  api.post("/checkpolicies", { uuid: id }).then((response) => {
    if (response.data.exists === false) {
      history.push(`/notfound`);
    } else if (response.data.success === true) {
      history.push(`/success`);
    } else if (response.data.success === false) {
      history.push(`/terms/${id}`);
    }
  });
  return <></>;
}

export default ValidateTerms;